/* The drawer's diagram tab: the version bar, then the two diagrams of that version. */
.diagram {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

/* v3 `.dg-bar`: "Versión", the picker and "Cada versión guarda sus dos diagramas." */
.bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.note {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}
